export default "__VITE_ASSET__B5TNb5Vn__"